// api.js 文件已经引入
import { getToken } from './api/api'
import store from './store/store'

function getAuthParams() {
  const appkey = getUrlParams('appkey')
  const handle = getUrlParams('handle')
  const lang = getUrlParams('lang')
  const code = getUrlParams('code')
  const timestamp = getUrlParams('timestamp')
  const sign = getUrlParams('sign')

  return {
    appkey,
    code,
    handle,
    lang,
    timestamp,
    sign
  }
}

function getUrlParams(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  // 先从 ?query 读取（Shopline 通常把参数放在 ? 后面）
  let r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return decodeURIComponent(r[2])
  }
  // 再从 hash 后面的 query 读取（兼容 /#/?key=val 格式）
  const hash = window.location.hash
  const hashQuery = hash.indexOf('?') !== -1 ? hash.substr(hash.indexOf('?') + 1) : ''
  let r2 = hashQuery.match(reg)
  if (r2 != null) {
    return decodeURIComponent(r2[2])
  }
  return null
}

async function checkPermissionWithRefresh(forceRefresh = false) {
  const params = getAuthParams()
  const handle = params.handle
  store.commit('setHandle', handle)

  // 从本地缓存获取 token，并校验 token 是否属于当前店铺
  const token = localStorage.getItem('token')
  const tokenHandle = localStorage.getItem('tokenHandle')

  if (!forceRefresh && token && tokenHandle === handle) {
    return true
  } else {
    try {
      // 通过接口请求获取 token
      await getToken(params)
      localStorage.setItem('tokenHandle', handle)
      return true
    } catch (error) {
      localStorage.removeItem('token')
      localStorage.removeItem('tokenHandle')
      return false
    }
  }
}

function getInstallationUrl() {
  const appkey = getUrlParams('appkey')
  const handle = getUrlParams('handle')
  if (!appkey || !handle) {
    return null
  }
  const responseType = 'code'
  const scope = 'read_products,write_products,read_metafileds'
  const redirectUri = encodeURIComponent('https://importify.keepuse.com')
  return `https://${handle}.myshopline.com/admin/oauth-web/#/oauth/authorize?appKey=${appkey}&responseType=${responseType}&scope=${scope}&redirectUri=${redirectUri}`
}

function redirectToInstallation() {
  const installationUrl = getInstallationUrl()
  if (installationUrl) {
    window.top.location = installationUrl
  }
}

export async function routerPermission(router) {
  router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      const token = localStorage.getItem('token')
      const tokenHandle = localStorage.getItem('tokenHandle')
      const urlHandle = getUrlParams('handle')

      // 路径 1：URL 有 handle，且缓存的 tokenHandle 匹配 → 直接放行
      if (urlHandle && token && tokenHandle === urlHandle) {
        store.commit('setHandle', urlHandle)
        next()
        return
      }

      // 路径 2：尝试通过 URL 参数获取新 token（从 Shopline 进入）
      const params = getAuthParams()
      if (params.appkey && params.handle && params.timestamp && params.sign) {
        try {
          await getToken(params)
          store.commit('setHandle', params.handle)
          localStorage.setItem('tokenHandle', params.handle)
          next()
          return
        } catch (error) {
          // 获取 token 失败，继续走下方兜底逻辑
        }
      }

      // 路径 3：没有有效 URL 参数，但本地已有 token → 放行（可能是 OAuth 回调后参数丢失的场景）
      if (token && tokenHandle) {
        // 从缓存恢复 handle 到 store，避免 store.state.handle 为空
        if (!store.state.handle) {
          store.commit('setHandle', tokenHandle)
        }
        next()
        return
      }

      // 路径 4：没有任何有效凭据，且有足够参数 → 跳回 Shopline 安装授权
      const installationUrl = getInstallationUrl()
      if (installationUrl) {
        // 防循环保护：60秒内不重复跳转，避免死循环
        const lastRedirect = localStorage.getItem('lastOAuthRedirect')
        const now = Date.now()
        if (lastRedirect && (now - parseInt(lastRedirect)) < 60000) {
          console.warn('[routerPermission] OAuth redirect loop detected, stopping.')
          next()
          return
        }
        localStorage.setItem('lastOAuthRedirect', String(now))
        window.top.location = installationUrl
      } else {
        // 参数不足时，停留在当前页（避免死循环）
        next()
      }
    } else {
      next()
    }
  })
}



// WEBPACK FOOTER //
// ./src/routerPermission.js